import {denormFn, normFn} from '../normalizerSupport';
import * as Types from './types';

export const normalize = normFn<Types.SemanticLegendObjSchema>(
  'semantic-legend',
  whole => whole
);

export const denormalize = denormFn<Types.SemanticLegendObjSchema>(
  part => part
);
